export const FLEECE_INVENTORY_REQUEST = "FLEECE_INVENTORY_REQUEST";
export const FLEECE_INVENTORY_SUCCESS = "FLEECE_INVENTORY_SUCCESS";
export const FLEECE_INVENTORY_FAILED = "FLEECE_INVENTORY_FAILED";
export const FLEECE_HISTORY_REQUEST = "FLEECE_HISTORY_REQUEST";
export const FLEECE_HISTORY_SUCCESS = "FLEECE_HISTORY_SUCCESS";
export const FLEECE_HISTORY_FAILED = "FLEECE_HISTORY_FAILED";
